"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpService = void 0;
var CommonService_decorator_1 = require("../../decorators/CommonService.decorator");
var Crypto_service_1 = require("../Crypto.service");
var User_service_1 = require("../User.service");
var Cache_service_1 = require("../storage/Cache.service");
var utils_1 = require("../eventCollector/core/utils");
var helper_1 = require("../../helper");
var defaultGlobalErrorHandler = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        console.warn('No global error handler was set, will ignore the global error. You can call httService.setGlobalErrorHandler(fn) to register one');
        return [2 /*return*/];
    });
}); };
var HttpService = /** @class */ (function () {
    function HttpService(userService, cryptoService, cacheService, seismicHelper) {
        this.userService = userService;
        this.cryptoService = cryptoService;
        this.cacheService = cacheService;
        this.seismicHelper = seismicHelper;
        this.responseInterceptors = [];
        this.globalErrorHandler = defaultGlobalErrorHandler;
        this.pendingPromiseMap = new Map();
    }
    HttpService.prototype.setGlobalErrorHandler = function (handler) {
        if (defaultGlobalErrorHandler !== this.globalErrorHandler) {
            console.error('You\'ve already set the globalErrorHandler, please check!');
        }
        this.globalErrorHandler = handler;
    };
    HttpService.prototype.addResponseInterceptor = function (responseInterceptor) {
        this.responseInterceptors.push(responseInterceptor);
    };
    HttpService.prototype.removeResponseInterceptor = function (responseInterceptor) {
        var index = this.responseInterceptors.indexOf(responseInterceptor);
        this.responseInterceptors.splice(index, 1);
    };
    /**
     * Helper method for DELETE request
     * @param url
     * @param options
     */
    HttpService.prototype.delete = function (url, options) {
        return this.request(__assign(__assign({}, options), { method: 'DELETE', url: url }));
    };
    /**
     * Helper method for GET request
     * @param url
     * @param options
     */
    HttpService.prototype.get = function (url, options) {
        return this.request(__assign(__assign({}, options), { method: 'GET', url: url }));
    };
    /**
     * Helper method for POST request
     * @param url
     * @param body
     * @param options
     */
    HttpService.prototype.post = function (url, body, options) {
        return this.request(__assign(__assign({}, options), { method: 'POST', url: url, body: body || (options === null || options === void 0 ? void 0 : options.body) || {} }));
    };
    /**
     * Helper method for PUT request
     * @param url
     * @param body
     * @param options
     */
    HttpService.prototype.put = function (url, body, options) {
        return this.request(__assign(__assign({}, options), { method: 'PUT', url: url, body: body || (options === null || options === void 0 ? void 0 : options.body) }));
    };
    /**
     * Helper method for PATCH request
     * @param url
     * @param body
     * @param options
     */
    HttpService.prototype.patch = function (url, body, options) {
        return this.request(__assign(__assign({}, options), { method: 'PATCH', url: url, body: body || (options === null || options === void 0 ? void 0 : options.body) }));
    };
    /**
     * Makes a request to the specified url. Will automatically add global headers unless
     * options.ignoreGlobalHeaders = true
     * @param options
     */
    HttpService.prototype.request = function (options) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var key, cacheKey, cacheItem, promise, req, _b, request, type, resolveValue, text, error, wasSuccess, retryValues, errors_1, innerGlobalErrorHandler;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        options.responseContentType = options.responseContentType || 'json';
                        options.headers = __assign(__assign({}, (options.ignoreGlobalHeaders === true ? {} : this.getGlobalHeaders())), options.headers);
                        // Add query strings to url
                        if (options.query) {
                            for (key in Object.keys(options.query)) {
                                if (!utils_1.hasOwnProperty(options.query, key)) {
                                    continue;
                                }
                                options.url += ((_a = options.url) === null || _a === void 0 ? void 0 : _a.indexOf('?')) === -1 ? '?' : '&';
                                options.url += key + "=" + encodeURIComponent(options.query[key]);
                            }
                        }
                        cacheKey = null;
                        if (!(options.cache && this.cryptoService.browserSupportsCrypto)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getCacheKey(options)];
                    case 1:
                        cacheKey = _c.sent();
                        cacheItem = this.cacheService.get(cacheKey);
                        if (cacheItem) {
                            // Return cached item
                            return [2 /*return*/, cacheItem.value];
                        }
                        _c.label = 2;
                    case 2:
                        promise = null;
                        if (cacheKey) {
                            if (this.pendingPromiseMap.has(cacheKey)) {
                                // Return already running promise
                                promise = this.pendingPromiseMap.get(cacheKey);
                            }
                            else {
                                promise = this.xmlHttpRequest(options);
                                this.pendingPromiseMap.set(cacheKey, promise);
                            }
                        }
                        else {
                            promise = this.xmlHttpRequest(options);
                        }
                        _c.label = 3;
                    case 3:
                        _c.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, promise];
                    case 4:
                        req = _c.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        _b = _c.sent();
                        request = _b.request, type = _b.type;
                        req = request;
                        console.error('xmlHttpRequest failed with ', type);
                        return [3 /*break*/, 6];
                    case 6:
                        text = req === null || req === void 0 ? void 0 : req.responseText;
                        try {
                            resolveValue = JSON.parse(text);
                        }
                        catch (e) {
                            resolveValue = text;
                            if (options.responseContentType === 'json') {
                                //isExpectedDataType = false;
                                console.error('We detected an error in `httpService` which suppose to get JSON-format data, while the server-side returned none-json content. If the none-JSON content is desired, please specific `responseContentType: \'text\'` when you call `httpService`.', options, 'response = ', text);
                            }
                        }
                        if (options.responseFailCallback) {
                            error = options.responseFailCallback(resolveValue);
                        }
                        else if (options.isLibraryService) {
                            if (req.status >= 400) {
                                error = {
                                    Message: 'Your internet connection appears to be having an issue, please try again.',
                                    resolveValue: resolveValue,
                                };
                            }
                            if (resolveValue.Error) {
                                error = resolveValue.Error;
                            }
                        }
                        wasSuccess = req.status >= 200 && req.status < 400 && !error;
                        if (wasSuccess && cacheKey) {
                            // Set response value and have it expire in x minutes (default to 60)
                            this.cacheService.set(cacheKey, resolveValue, options.cache, options.cacheExpirationMinutes || 60);
                            this.pendingPromiseMap.delete(cacheKey);
                        }
                        _c.label = 7;
                    case 7:
                        _c.trys.push([7, 9, , 10]);
                        return [4 /*yield*/, Promise.all(this.responseInterceptors.map(function (rI) { return rI.intercept(req); }))];
                    case 8:
                        retryValues = _c.sent();
                        if (retryValues.length > 0 && !retryValues.find(function (x) { return x === false; })) {
                            return [2 /*return*/, this.request(options)];
                        }
                        return [3 /*break*/, 10];
                    case 9:
                        errors_1 = _c.sent();
                        console.error('Failed to run HttpService interceptors', errors_1);
                        return [3 /*break*/, 10];
                    case 10:
                        if (wasSuccess) {
                            if (options.isLibraryService && options.responseContentType === 'json') {
                                return [2 /*return*/, Promise.resolve(resolveValue.ServiceResult)];
                            }
                            else {
                                return [2 /*return*/, Promise.resolve(resolveValue)];
                            }
                        }
                        else if (this.globalErrorHandler) {
                            innerGlobalErrorHandler = function () { return _this.globalErrorHandler && _this.globalErrorHandler({
                                request: req,
                                resolveValue: resolveValue,
                                error: error || resolveValue,
                                retryCallback: options.retryCallback,
                                preventGlobalErrorDialog: options.preventGlobalErrorDialog,
                                isLibraryService: options.isLibraryService,
                            }); };
                            if (options.dirtySolutionErrorHandler) {
                                return [2 /*return*/, options.dirtySolutionErrorHandler(req.status || 0, resolveValue, innerGlobalErrorHandler)];
                            }
                            else {
                                return [2 /*return*/, innerGlobalErrorHandler()];
                            }
                        }
                        else {
                            return [2 /*return*/, Promise.reject(error || resolveValue)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    HttpService.prototype.xmlHttpRequest = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var req = new XMLHttpRequest();
            // tslint:disable-next-line:only-arrow-functions
            req.addEventListener('load', function () {
                resolve(this);
            });
            req.addEventListener('abort', function () {
                reject({ request: req, type: 'abort' });
            });
            req.addEventListener('error', function () {
                reject({ request: req, type: 'error' });
            });
            req.addEventListener('timeout', function () {
                reject({ request: req, type: 'timeout' });
            });
            req.open(options.method, options.url);
            if (options.credentials === 'include') {
                req.withCredentials = true;
            }
            else if (options.credentials === 'omit') {
                req.withCredentials = false;
            }
            var omitContentTypeInHeaders = false;
            if (options.body instanceof window.FormData || options.body instanceof window.Blob) {
                omitContentTypeInHeaders = true;
            }
            else if (typeof options.body === 'string') {
                // Keep it
            }
            else {
                options.body = JSON.stringify(options.body);
            }
            _this.addHeadersToHttpRequest(req, options.headers, omitContentTypeInHeaders);
            req.send(options.body);
        });
    };
    HttpService.prototype.addHeadersToHttpRequest = function (request, headers, omitContentType) {
        if (!headers) {
            return;
        }
        for (var key in headers) {
            if ((key || '').toLowerCase() === 'content-type' && omitContentType) {
                continue;
            }
            if (utils_1.hasOwnProperty(headers, key)) {
                request.setRequestHeader(key, headers[key]);
            }
        }
    };
    HttpService.prototype.getGlobalHeaders = function (profileVersionId) {
        var headers = {
            accept: 'application/json, text/plain, */*',
            'Content-Type': 'application/json;charset=UTF-8',
        };
        var loginInfo = this.userService.getLoginInfo();
        if (profileVersionId) {
            headers.SeismicClientName = this.seismicHelper.getClientType();
            headers.ProfileVersionId = profileVersionId;
        }
        else {
            headers.SeismicClientName = this.seismicHelper.getClientType();
            headers.ProfileVersionId = (loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.clientInfo.profileVersionIdNewsCenter) || (loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.clientInfo.profileVersionId) || '';
            headers.TeamSiteId = (loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.clientInfo.teamSiteId) || (loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.clientInfo.teamSiteIdInContentManager) || '';
        }
        headers.Authorization = this.userService.getAccessToken();
        if (window.EmbeddedPage && window.EmbeddedPage.seismicIntegratorContext) {
            var context = JSON.parse(window.EmbeddedPage.seismicIntegratorContext);
            context.ContextName = this.encodeHeader(context.ContextName);
            context.ContextType = this.encodeHeader(context.ContextType);
            context.ContextTypePlural = this.encodeHeader(context.ContextTypePlural);
            headers.SeismicIntegratorContext = JSON.stringify(context);
        }
        else {
            if (typeof window.SeismicSFDCClient !== 'undefined') {
                headers.SeismicIntegratorContext = window.SeismicSFDCClient.Current.Salesforce.SeismicIntegratorContext;
            }
        }
        return headers;
    };
    HttpService.prototype.getCacheKey = function (options) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var queryParamsToIgnoreInHash, url, urlSplit, queryParamsObj_1, key, optionsCopy, optionsAsStr, signature;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.cryptoService.browserSupportsCrypto) {
                            throw new Error('getCacheKey cannot generate a key in this browser.');
                        }
                        queryParamsToIgnoreInHash = ['timestamp', 'signature'];
                        url = options.url;
                        urlSplit = url === null || url === void 0 ? void 0 : url.split('?');
                        // Because some APIs use things like a signature with a timestamp, creating a hash will always be different
                        // even if we want to actually cache the result. This is a workaround!
                        if ((urlSplit === null || urlSplit === void 0 ? void 0 : urlSplit.length) === 2) {
                            queryParamsObj_1 = JSON.parse('{"' + decodeURI(urlSplit[1].replace(/&/g, '","').replace(/=/g, '":"')) + '"}');
                            queryParamsToIgnoreInHash.forEach(function (key) { return delete queryParamsObj_1[key]; });
                            url = urlSplit[0] + "?";
                            for (key in queryParamsObj_1) {
                                if (utils_1.hasOwnProperty(queryParamsObj_1, key)) {
                                    url += key + "=" + queryParamsObj_1[key];
                                }
                            }
                        }
                        optionsCopy = __assign(__assign({}, options), { url: url });
                        optionsAsStr = JSON.stringify(optionsCopy);
                        return [4 /*yield*/, this.cryptoService.hmacSha1(optionsAsStr, (_a = this.userService.getLoginInfo()) === null || _a === void 0 ? void 0 : _a.accessKey)];
                    case 1:
                        signature = _b.sent();
                        return [2 /*return*/, signature];
                }
            });
        });
    };
    HttpService.prototype.encodeHeader = function (headerValue) {
        return 'encoded:' + btoa(encodeURIComponent(headerValue).replace(/%([0-9A-F]{2})/g, function toSolidBytes(match, p1) {
            return String.fromCharCode(('0x' + p1));
        }));
    };
    HttpService = __decorate([
        CommonService_decorator_1.CommonService('HttpService'),
        __metadata("design:paramtypes", [User_service_1.UserService,
            Crypto_service_1.CryptoService,
            Cache_service_1.CacheService,
            helper_1.SeismicHelper])
    ], HttpService);
    return HttpService;
}());
exports.HttpService = HttpService;
//# sourceMappingURL=Http.service.js.map